import axios from 'axios';
import { __ } from "../app"
import { apiHost, authHost } from "../config"
import { fetchResultsByTerm, useFetchResultByUrl } from './helpers/autocomplete-service';

export async function autocomplete( term, { abortController = AbortController } ) {
    var url = apiHost + '/api/admin/Site/autocomplete';
    return await fetchResultsByTerm( url, term, { abortController } )
}

export function useSite( siteId = false, { context = 'autocomplete' } = {} ) {

    var fetchParams = {
        getId: r => r?.id,
        getUrl: r => apiHost + '/api/admin/site/' + parseInt( r?.id ),
        initialState: {
            id: siteId
        }
    } 

    if( context == 'autocomplete' ) {
        fetchParams = {
            getId: r => r?.siteId,
            getUrl: r => apiHost + '/api/admin/site/autocomplete/' + parseInt( r?.siteId ),
            initialState: {
                siteId
            }
        }
    }

    return useFetchResultByUrl( fetchParams );
}


export async function createSite( siteModel ) {
    
    try {
        const response = await axios.post( apiHost + '/api/admin/site',  { 
            ...siteModel,
            id: 0
        } );

        return response;
    }
    catch( e ) {
        return {
            error: true,
            message: e?.response?.data
        }
    }
}



export async function updateSite( siteModel ) {

    try {
        const response = await axios.put( apiHost + '/api/admin/site/' + siteModel?.id, siteModel )
        return response;
    }
    catch( e ) {
        return {
            error: true,
            message: e?.response?.data
        }
    }
}